import {Component, input} from '@angular/core';

import {Contact} from '../../types/contact'
import {UiCoreComponentsModule} from "@softline/ui-core";

@Component({
    selector: 'soft-contact-card',
    imports: [UiCoreComponentsModule],
    templateUrl: './contact-card.component.html',
    styleUrl: './contact-card.component.css'
})
export class ContactCardComponent {
  contact = input<Contact>()
}
